import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'ebb-portal-dialog-switch-dashboard',
  templateUrl: './dialog-switch-dashboard.component.html',
  styles: []
})
export class DialogSwitchDashboardComponent implements OnInit {
  public switchForm: FormGroup;
  public _currentUserType: string;

  constructor(
    public dialogRef: MatDialogRef<DialogSwitchDashboardComponent>,
    private readonly fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this._currentUserType = data.currentUserType;
   }

  ngOnInit() {
    this.initializeForms();
  }

  private initializeForms(): void {
    // Owner: 700000000; Contractor: 700000001
    this.switchForm = this.fb.group({
      userDashboard: ''
    });

    this.switchForm.get('userDashboard').setValue(this._currentUserType);
  }

  public onClickCancel(): void {
    this.dialogRef.close();
  }

  public onClickSwitch(): void {
    this.dialogRef.close(this.switchForm.get('userDashboard').value);
  }

}
